import { CategoryIcon, resolveCategoryForIcon, getCategoryBreadcrumb } from "../../../lib/categoryIcons";
import { getArticleStatus, STATUS_CLASSES } from "../../../lib/stockDisplay";
import { StockArticleActions } from "../../../components/StockArticleActions";

const COLONNES = [
  { key: "negative", label: "Stock négatif" },
  { key: "out", label: "Rupture" },
  { key: "low", label: "Stock bas" },
  { key: "ok", label: "En stock" },
];

// Modèle 5 — Priorité stock : colonnes par statut, pour une session de
// réapprovisionnement — on voit immédiatement où porter son attention.
export function PriorityStockView({ articles, categories, isTestMode, user, canEditAnyStockField, canTransfer, onEdit, onTransfer, onDelete, uploadsBase }) {
  const parStatut = { negative: [], out: [], low: [], ok: [] };
  articles.forEach((a) => { parStatut[getArticleStatus(a, isTestMode).key].push(a); });
  // La colonne "Stock négatif" est un cas rare (erreur de saisie/synchro) —
  // ne l'affiche que si elle contient vraiment quelque chose, pour ne pas
  // encombrer l'écran en temps normal.
  const colonnesAffichees = COLONNES.filter((c) => c.key !== "negative" || parStatut.negative.length > 0);

  return (
    <div
      className="grid gap-4 items-start"
      style={{ gridTemplateColumns: `repeat(${colonnesAffichees.length}, minmax(0, 1fr))` }}
      data-testid="stock-view-priorite"
    >
      {colonnesAffichees.map((col) => {
        const cls = STATUS_CLASSES[col.key];
        const items = parStatut[col.key];
        return (
          <div key={col.key} className="rounded-xl border border-border bg-card overflow-hidden">
            <div className="flex items-center gap-2 px-3.5 py-2.5 border-b border-border">
              <span className={`w-2 h-2 rounded-full ${cls.dot}`} />
              <span className="text-sm font-semibold">{col.label}</span>
              <span className="ml-auto text-xs text-muted-foreground font-mono">{items.length}</span>
            </div>
            <div className="p-2.5 space-y-2 max-h-[65vh] overflow-y-auto">
              {items.map((a) => (
                <div
                  key={a.id} className="rounded-lg border border-border bg-secondary/40 p-2.5 cursor-pointer hover:border-primary group"
                  onClick={() => canEditAnyStockField && onEdit(a)} data-testid={`stock-priority-card-${a.id}`}
                >
                  <div className="flex items-start gap-2">
                    <div className="w-7 h-7 rounded-md bg-secondary flex items-center justify-center overflow-hidden shrink-0">
                      {a.photo_url ? (
                        <img src={`${uploadsBase}${a.photo_url}`} alt={a.nom} className="w-full h-full object-cover" />
                      ) : (
                        <CategoryIcon category={resolveCategoryForIcon(categories, a.categorie)} uploadsBase={uploadsBase} size={13} className="text-muted-foreground" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12.5px] font-medium truncate">{a.nom}</p>
                      <p className="text-[10px] text-muted-foreground truncate">{getCategoryBreadcrumb(categories, a.categorie)} · {a.code || a.id.slice(-6)}</p>
                    </div>
                    <StockArticleActions
                      article={a} user={user} canEditAnyStockField={canEditAnyStockField} canTransfer={canTransfer}
                      onEdit={onEdit} onTransfer={onTransfer} onDelete={onDelete}
                      className="hidden group-hover:flex gap-1 shrink-0"
                    />
                  </div>
                  <div className="flex items-center justify-between mt-1.5 text-[11px]">
                    <span className={`font-mono ${cls.text}`}>Qté: {a.quantite}</span>
                    <span className="font-mono font-semibold">{Number(a.prix_ttc ?? a.prix ?? 0).toFixed(2)} €</span>
                  </div>
                </div>
              ))}
              {items.length === 0 && (
                <p className="text-center text-xs text-muted-foreground py-4">Aucun article.</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
